import { ADD_PRODUCT, REMOVE_PRODUCT, SET_SELECTED_PRODUCTS } from "./Actions";

export const ConfigReducer = (state, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      return {
        ...state,
        selectedProducts: [...state.selectedProducts, action.payload],
      };
    case REMOVE_PRODUCT:
      return {
        ...state,
        selectedProducts: state.selectedProducts.filter(
          (id) => id !== action.payload
        ),
      };
      case SET_SELECTED_PRODUCTS:
        return {
          ...state,
          selectedProducts: action.payload,
        };
    default:
      return state;
  }
};

export default ConfigReducer;